import React from "react";
import { InfoWindow } from "@react-google-maps/api";
import { Card } from "antd";
import { Link } from "react-router-dom";

const WHITE_TEXT_COLOR = [
  "#d9ef8b",
  "#a6d96a",
  "#66bd63",
  "#1a9850",
  "#006837",
];

function HouseInfoWindow({ house, onClose, isForecast }) {
  let style = {
    width: 300,
    border: "none",
    backgroundColor: isForecast ? house?.forecast_color : house?.pic0_color,
    color: isForecast
      ? WHITE_TEXT_COLOR.includes(house?.forecast_color)
        ? "white"
        : "black"
      : WHITE_TEXT_COLOR.includes(house?.pic0_color)
      ? "white"
      : "black",
  };

  return (
    <InfoWindow
      position={{ lat: house.lat, lng: house.lon }}
      onCloseClick={onClose}
    >
      <Card
        title={
          <Link
            to={house?.infoWindow?.content?.to}
            style={{ color: "white", cursor: "pointer" }}
          >
            {house?.infoWindow?.content?.title}
          </Link>
        }
        style={style}
      >
        <p>
          Forecast:{" "}
          {isForecast
            ? house?.infoWindow?.content?.forecast
            : house?.infoWindow?.content?.pic0}{" "}
          %
        </p>
        <p> Beds: {house?.infoWindow?.content?.beds}</p>
        <p> Baths: {house?.infoWindow?.content?.baths}</p>
        <p>Sq Ft: {house.infoWindow?.content?.sqft}</p>
        <p>Year Built: {house?.infoWindow?.content?.yearBuilt}</p>
      </Card>
    </InfoWindow>
  );
}

export default HouseInfoWindow;
